import { TYPES, FLAGS, FLAGS_CONFIG } from './constants';

const withDefault = castFunction => (value, options) => {
  if (!value) {
    return castFunction(options.default, options);
  }

  return castFunction(value, options);
};

const CAST_FUNCTIONS = {
  [TYPES.BOOLEAN]: withDefault(value => value.toUpperCase() === 'TRUE'),
  [TYPES.ARRAY]: withDefault((value, options) =>
    value.split(options.separator)
  ),
  [TYPES.STRING]: withDefault(value => value),
};

export const parseFeatureFlags = (featureFlags = {}) => {
  return FLAGS.reduce((result, flag) => {
    const { type, ...options } = FLAGS_CONFIG[flag];
    const flagValue = featureFlags[flag];

    return {
      ...result,
      [flag]: CAST_FUNCTIONS[type](flagValue, options),
    };
  }, {});
};
